import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

const CACHEABLE_PATTERNS = ['/Catalogos/', '/sistemas', '/organos', '/roles', '/puestos'];
const CACHE_TTL_MS = 5 * 60 * 1000;

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cache = new Map<string, { response: HttpResponse<unknown>; expires: number }>();

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET') return next.handle(req);

    const cacheable = CACHEABLE_PATTERNS.some((p) => req.url.includes(p));
    if (!cacheable) return next.handle(req);

    const cached = this.cache.get(req.url);
    if (cached && cached.expires > Date.now()) {
      return of(cached.response.clone());
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cache.set(req.url, {
            response: event,
            expires: Date.now() + CACHE_TTL_MS,
          });
        }
      }),
    );
  }
}
